export default "__VITE_PUBLIC_ASSET__1f04e7a4__"